import { createCustomerOrgUnitScope } from '@/helpers/queryKeyScopes'

const scope = createCustomerOrgUnitScope('getMultipleFavoriteListKeys')

export const getMultipleFavoriteListKeys = {
  ...scope,
  list: (
    customerId: string,
    orgUnitId: string,
    currentPage: number,
    itemsPerPage: number,
    sortingOption: string,
    searchText: string,
    sortCreatedBy: string
  ) => {
    return [
      ...scope.orgUnit(customerId, orgUnitId),
      currentPage,
      itemsPerPage,
      sortingOption,
      searchText,
      sortCreatedBy,
    ]
  },
} as const
